import { render } from "./DashboardCmpWrapper.vue?vue&type=template&id=4e75aa25&ts=true"
import script from "./DashboardCmpWrapper.vue?vue&type=script&lang=ts"
export * from "./DashboardCmpWrapper.vue?vue&type=script&lang=ts"

import "./DashboardCmpWrapper.vue?vue&type=style&index=0&id=4e75aa25&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/wrapper/DashboardCmpWrapper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4e75aa25"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4e75aa25', __exports__)) {
    api.reload('4e75aa25', __exports__)
  }
  
  module.hot.accept("./DashboardCmpWrapper.vue?vue&type=template&id=4e75aa25&ts=true", () => {
    api.rerender('4e75aa25', render)
  })

}


export default __exports__